import { Theme } from "@emotion/react";
import { List, ListItem, ListItemText, SxProps } from "@mui/material";
import React, { ReactNode } from "react"
import { ItensProps } from "../../pages/Pedidos/PedidosPage";

interface ListProps {
    sx?: SxProps<Theme>;
    listSx?: SxProps<Theme>;
    list: ItensProps[];

    renderItem?: (item: ItensProps) => React.ReactNode;
}

const ListComponent = (props: ListProps) => {
    return <List
        //sx={{ listStyle: "initial", pl: 4 }}
        sx={props.sx}
    >
        {props.list.map((element: ItensProps, index: number) => {
            return <ListItem sx={{ display: "list-item", padding: 0 }} key={`list-item-${index}`}>
                <ListItemText 
                    primary={element.titulo} 
                    secondary={props.renderItem?.(element)}
                    secondaryTypographyProps={{
                        component: "div"
                    }}
                    sx={props.listSx}
                />
            </ListItem>
        })}
    </List>
}

export default ListComponent;